const PROJECT_NAME = 'Universal Login MFA Roles';

import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist';
import rootReducer from './Reducers';
import thunk from 'redux-thunk';

// Custom logger middleware
const logger = store => next => action => {
    console.group(action.type);
    console.log('Previous state:', store.getState());
    console.log('Action:', action);
    const result = next(action);
    console.log('Next state:', store.getState());
    console.groupEnd();
    return result;
};

const persistConfig = {
    key: PROJECT_NAME.toLowerCase().replace(/\s+/g, '_'),
    storage,
};
const axiosInstance = {}

const persistedReducer = persistReducer(persistConfig, rootReducer);
//redux store configuration 
const store = createStore(
    persistedReducer,
    applyMiddleware(
        thunk.withExtraArgument(axiosInstance),
        //logger // Add the custom logger middleware
    )
);



export default store;
